export const manhourCalculator = (type,complexity) => {
    const manhourMatrix = {
        EI: { ต่ำ: 10, กลาง: 40, สูง: 70 },
        EO: { ต่ำ: 10, กลาง: 40, สูง: 70 },
        EQ: { ต่ำ: 10, กลาง: 40, สูง: 70 },
        ILF: { ต่ำ: 8, กลาง: 16, สูง: 24 },
        EIF: { ต่ำ: 8, กลาง: 16, สูง: 24 },
    };

    return manhourMatrix[type][complexity] || 0;
};